import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Cutttingedge(props) {
  return (
    <div className="p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <div className="example center text-center" data-text="App">
              <h2>
                Don’t let outdated healthcare technology hold you back. With 94%
                of the younger population indicating a desire to improve their
                health through apps, it's time to take action.
              </h2>
            </div>
            <p>
              Collaborate with our health app developers to modernize your
              software
            </p>

            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Discuss Your Project!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Cutttingedge;
